import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, HeartHandshake } from "lucide-react";
import { useHelpedGuides } from "@/hooks/useHelpedGuides";
import { GuideNoteEditor } from "@/components/GuideNoteEditor";

// "This helped" button at the end of a guide (signed-in members only), with an optional one-line note
export const ThisHelped = ({ slug, title }) => {
  const { enabled, list, isHelped, toggle, noteOf, saveNote } = useHelpedGuides();
  const [asking, setAsking] = useState(false);
  if (!enabled || list === null) return null;
  const on = isHelped(slug);
  const note = noteOf(slug);

  const click = async () => {
    setAsking(!on);
    await toggle(slug, title);
  };

  return (
    <div className="mm-card p-5 mt-10" data-testid="article-this-helped">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-semibold">Did this guide help?</div>
          <div className="text-sm text-mm-muted">{on ? "Saved, so you can find it again anytime." : "Save it to your guides so it's easy to come back to."}</div>
        </div>
        <div className="flex items-center gap-3">
          {on && <Link to="/guides" className="text-sm text-mm-primary font-medium" data-testid="article-guides-link">Your guides</Link>}
          <button onClick={click} className={on ? "mm-btn-ghost !py-2 !px-4 text-sm bg-mm-primary/10 text-mm-primary" : "mm-btn !py-2 !px-4 text-sm"} data-testid="article-this-helped-btn">
            {on ? <><Check size={15} />It helped</> : <><HeartHandshake size={15} />This helped</>}
          </button>
        </div>
      </div>
      {on && asking && (
        <div className="mt-4 pt-4 border-t mm-fade-up" data-testid="article-helped-note">
          <div className="text-sm font-medium mb-2">What helped most? <span className="text-mm-muted font-normal">(optional, just for you)</span></div>
          <GuideNoteEditor initial={note} testPrefix="article-helped-note" onSave={(t) => saveNote(slug, t)} onCancel={() => setAsking(false)} />
        </div>
      )}
      {on && !asking && note && <p className="text-sm mt-3 mm-soft p-3 rounded-2xl break-words [overflow-wrap:anywhere]" data-testid="article-helped-note-text">“{note}”</p>}
    </div>
  );
};
